<template>
  <div>
    <a-row :span="24">
      <a-alert
        v-if="language_check_failed"
        message="Language change detected!"
        description="There is a language change in the webpage. This change of language could be an indicator that the webpage is defaced."
        type="warning"
        show-icon
      />
    </a-row>
    <a-row style="padding: 5px;margin-top: 10px">
      <div style="display: flex; justify-content: space-evenly">
        <div>
          <a-progress
            type="circle"
            :stroke-color="englishProbability < 0.5 ? '#ff4d4f': '#52c41a'"
            :percent="english_probability_display"
            status="active"
          >
            <template #format>
              <div>
                English<br>Probability:
              </div>
              <div style="font-size: 21px; font-weight: 600">
                {{ english_probability_display }}%
              </div>
            </template>
          </a-progress>
        </div>
        <div>
          <a-progress
            type="circle"
            :stroke-color="englishProportion < 0.5 ? '#ff4d4f': '#52c41a'"
            :percent="english_proportion_display"
            status="active"
          >
            <template #format>
              <div>
                English<br>Proportion:
              </div>
              <div style="font-size: 21px; font-weight: 600">
                {{ english_proportion_display }}%
              </div>
            </template>
          </a-progress>
        </div>
      </div>
    </a-row>
  </div>
</template>
<script>
export default {
  name: "LanguagePredictionResult",
  props:{
    englishProbability: {
      type: Number,
      required: true
    },
    englishProportion: {
      type: Number,
      required: true
    }
  },
  computed: {
    english_probability_display(){
      return Math.round(this.englishProbability * 100);
    },
    english_proportion_display(){
      return Math.round(this.englishProportion * 100);
    },
    language_check_failed(){
      return (this.englishProbability < 0.5) || (this.englishProportion < 0.5);
    }
  }
}
</script>
<style lang="css">
.percentage_display{
  font-size: 21px; 
  font-weight: 600
}
</style>